import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const JoditTextEditor = (props) => {
    const { value, handleChange, readOnly, height, marginBottom } = props
    const [editorLoaded, setEditorLoaded] = useState(false);

    useEffect(() => {
        // Ensure the component only renders on the client side
        setEditorLoaded(true);
    }, []);

    const getTextDirection = (text) => {
  const urduRegex = /[\u0600-\u06FF]/;
  return urduRegex.test(text) ? 'rtl' : 'ltr';
};
const direction = getTextDirection(value);
    return (
        <>
        {editorLoaded ? (
        <ReactQuill
            value={value}
            onChange={handleChange}
            readOnly={readOnly}
            style={{
                height:height, 
                marginBottom:marginBottom,
                direction
            }}
        />
    ) : (
        <p>Loading editor...</p>
    )}
    </>
    );
}

export default JoditTextEditor;
